import en from "./en";

// Language: Arabic (default, right-to-left) or English (left-to-right). The choice is saved in localStorage and
// is fixed for the lifetime of a page: switching saves it and reloads, so every label (including constants
// built when a module loads) is evaluated again in the new language. Arabic text is its own key; `en` maps
// it to English. A text without an English entry is shown as written, never blank.
// Only labels change: amounts, currencies, dates and calculations never depend on the language.
export const LANG_KEY = "lang";

const readLang = () => {
  try {
    return window.localStorage.getItem(LANG_KEY) === "en" ? "en" : "ar";
  } catch (e) {
    return "ar";
  }
};

export const lang = readLang();
export const isEnglish = lang === "en";
export const DIR = isEnglish ? "ltr" : "rtl";
export const LOCALE = isEnglish ? "en-GB" : "ar-EG";

// "{name}" placeholders are filled from `vars`.
export function t(text, vars) {
  let out = isEnglish && Object.prototype.hasOwnProperty.call(en, text) ? en[text] : text;
  if (vars) out = out.replace(/\{(\w+)\}/g, (match, key) => (key in vars ? vars[key] : match));
  return out;
}

// Server messages arrive in the language the request asked for; Arabic ones are mapped when English is on.
export const tServer = (message) => (typeof message === "string" ? t(message) : message);

export function applyLanguage(next) {
  const root = document.documentElement;
  root.setAttribute("lang", next);
  root.setAttribute("dir", next === "en" ? "ltr" : "rtl");
}

export function setLanguage(next) {
  try {
    window.localStorage.setItem(LANG_KEY, next === "en" ? "en" : "ar");
  } catch (e) {
    // private mode: the switch still applies to this page load only
  }
  window.location.reload();
}
